import { redirect } from "next/navigation";
import { auth } from "@clerk/nextjs/server";
import { createAdminClient } from "@/lib/supabase/server";
import OnboardingPage from "./OnboardingPage";

export default async function OnboardingRoute() {
  const { userId } = await auth();
  if (!userId) redirect("/sign-up");

  const supabase = await createAdminClient();
  const { data } = await supabase
    .from("organisation_members")
    .select("organisation_id")
    .eq("user_id", userId)
    .maybeSingle();

  if (data) redirect("/dashboard");

  return <OnboardingPage />;
}

